import React from "react";
import Skeleton from "react-loading-skeleton";

function AnalyticsChart({
  title,
  eyebrow,
  description,
  loading,
  isEmpty,
  noDataLabel,
  emptyIcon = "zmdi-chart",
  toolbar,
  aside,
  footer,
  children,
  cardClassName = "",
  contentClassName = "",
  canvasClassName = "",
  loadingHeight = 300,
}) {
  const cardClasses = ["card", "analytics-chart", cardClassName].filter(Boolean).join(" ");
  const contentClasses = [
    "analytics-chart__content",
    aside ? "analytics-chart__content--split" : null,
    contentClassName,
  ].filter(Boolean).join(" ");
  const canvasClasses = ["analytics-chart__canvas", canvasClassName].filter(Boolean).join(" ");

  return (
    <div className={cardClasses}>
      <div className="card-body">
        {(eyebrow || title || description || toolbar) && (
          <div className="analytics-chart__head">
            <div className="analytics-chart__copy">
              {eyebrow && <span className="analytics-chart__eyebrow">{eyebrow}</span>}
              {title && <h6 className="analytics-chart__title">{title}</h6>}
              {description && <p className="analytics-chart__description">{description}</p>}
            </div>
            {toolbar && <div className="analytics-chart__toolbar">{toolbar}</div>}
          </div>
        )}

        {loading ? (
          <Skeleton height={loadingHeight} />
        ) : isEmpty ? (
          <div className="analytics-chart__empty text-center text-muted py-5">
            <i className={`zmdi ${emptyIcon} zmdi-hc-3x d-block mb-2`} />
            <p className="mb-0">{noDataLabel || "No data"}</p>
          </div>
        ) : (
          <>
            <div className={contentClasses}>
              <div className={canvasClasses}>{children}</div>
              {aside && <div className="analytics-chart__aside">{aside}</div>}
            </div>
            {footer && <div className="analytics-chart__footer">{footer}</div>}
          </>
        )}
      </div>
    </div>
  );
}

export default AnalyticsChart;
